<template>
  <button class="cursor-pointer relative" @click="handleClick">
    <IconsShoppingCart :iconClass="props.iconClass" :variant="props.variant" />
    <span
      v-if="totalItems > 0"
      class="absolute -top-1 -right-2 bg-secondary text-white rounded-full text-xs w-5 h-5 flex items-center justify-center"
    >
      {{ totalItems }}
    </span>
  </button>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useCartStore } from "~/stores/cart";

interface CartMenuProps {
  iconClass?: string;
  variant?: "default" | "dark";
}

const props = defineProps<CartMenuProps>();

const emit = defineEmits<{
  (e: "clicked"): void;
}>();

const cartStore = useCartStore();
const { totalItems } = storeToRefs(cartStore);

const handleClick = () => {
  emit("clicked");
};
</script>
